<template>
  <div :class="[onlyIcon ? 'mobile-wrap' : '']">
    <ui-google :onlyIcon="onlyIcon" :action="onGoogleSignInClick"></ui-google>
    <ui-facebook :action="loginFacebook" :onlyIcon="onlyIcon"></ui-facebook>
    <ui-apple
      :onlyIcon="onlyIcon"
      @appleAccountAuth="authorizeApple"
    ></ui-apple>
    <ui-discord :onlyIcon="onlyIcon" :action="initDiscordAuth"></ui-discord>
  </div>
</template>

<script>
import { authComputed } from "@/store/helpers.js";
import UiFacebook from "./UiFacebook";
import UiGoogle from "./UiGoogle";
import UiApple from "./UiApple.vue";
import UiDiscord from "./UiDiscord.vue";

export default {
  components: {
    UiFacebook,
    UiGoogle,
    UiApple,
    UiDiscord
  },
  props: {
    verifyAccountMethod: {
      type: String,
      default: ""
    },
    verifyAccounValue: {
      type: String,
      default: ""
    },
    onlyIcon: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tokenClient: null,
      googleReady: false
    };
  },
  mounted() {
    this.initFacebookLogin();
    this.loadGapiAndAfterwardsInitAuth();
  },
  computed: {
    ...authComputed
  },
  methods: {
    loadGapiAndAfterwardsInitAuth() {
      const script = document.createElement("script");
      script.src = "https://accounts.google.com/gsi/client";
      script.async = true;
      script.defer = true;

      script.onload = () => {
        this.googleReady = true;
        this.initGoogleLogin(); // only call when script is ready
      };

      document.head.appendChild(script);
    },
    initGoogleLogin() {
      if (!window.google || !window.google.accounts) {
        console.error("Google Identity Services not loaded yet.");
        return;
      }
      this.tokenClient = window.google.accounts.oauth2.initTokenClient({
        client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
        scope: "profile email openid",
        callback: response => {
          if (response.error) {
            console.error("Google Sign-In Error:", response);
            return;
          }

          const accessToken = response.access_token;
          this.clearStorage();
          this.$store.dispatch("registerWithGoogle", accessToken).then(() => {
            this.$router.push({
              path: "/login",
              query: { signIn: "1" }
            });
          });
        }
      });
    },
    onGoogleSignInClick() {
      if (!this.tokenClient) {
        console.error("Google token client not initialized.");
        return;
      }

      this.tokenClient.requestAccessToken();
    },
    authorizeApple({ code }) {
      this.clearStorage();
      this.$store.dispatch("authorizeWithApple", { code }).then(() => {
        if (this.getAuthAction === "login") {
          this.$router.push({
            path: "/login",
            query: { singIn: "1" }
          });
        } else {
          this.$router.push({
            path: "/createAccount",
            query: { singIn: "1" }
          });
        }
      });
    },
    initDiscordAuth() {
      this.clearStorage();
      const uri = encodeURIComponent(process.env.VUE_APP_DISCORD_REDITRECT_URI);
      const discordAuthUri = `https://discord.com/api/oauth2/authorize?client_id=${process.env.VUE_APP_DISCORD_CLIENT_ID}&response_type=code&redirect_uri=${uri}&scope=identify+email`;

      window.location.href = discordAuthUri;
    },
    initFacebookLogin() {
      window.fbAsyncInit = function() {
        window.FB.init({
          appId: process.env.VUE_APP_FACEBOOK_APP_ID,
          cookie: true,
          xfbml: true,
          version: "v17.0"
        });

        window.FB.AppEvents.logPageView();
      };

      (function(d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      })(document, "script", "facebook-jssdk");
    },
    loginFacebook() {
      this.clearStorage();
      window.FB.login(
        response => {
          if (response.authResponse && response.status === "connected") {
            this.$store
              .dispatch(
                "registerWithFacebook",
                response.authResponse.accessToken
              )
              .then(() => {
                if (this.getAuthAction === "login") {
                  this.$router.push({
                    path: "/login",
                    query: { singIn: "1" }
                  });
                } else {
                  this.$router.push({
                    path: "/createAccount",
                    query: { singIn: "1" }
                  });
                }
              });
          }
        },
        {
          scope: "public_profile,email",
          auth_type: "rerequest"
        }
      );
    },
    clearStorage() {
      localStorage.clear();
      sessionStorage.clear();
    }
  }
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: #ffffff;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
}

.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
}

.modal-header {
  position: relative;
  border-bottom: 1px solid #eeeeee;
  color: #4aae9b;
  justify-content: space-between;
}

.modal-footer {
  border-top: 1px solid #eeeeee;
  flex-direction: column;
  justify-content: flex-end;
}

.modal-body {
  position: relative;
  padding: 20px 10px;
}

.btn-close {
  position: absolute;
  top: 0;
  right: 0;
  border: none;
  font-size: 20px;
  padding: 10px;
  cursor: pointer;
  font-weight: bold;
  color: #4aae9b;
  background: transparent;
}

.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
}
</style>
